<template>
    <MobileFullPageLayout
        v-if="this.$vuetify.breakpoint.xsOnly"
    />
    <AppLayout v-else />
</template>
<script>
import MobileFullPageLayout from './MobileFullPageLayout.vue';
export default {
    name: 'MobileFullPageAppLayout',
    components: {
        AppLayout: () => import('./AppLayout.vue'),
        MobileFullPageLayout,
    },
};
</script>
